/* eslint-disable @typescript-eslint/no-non-null-assertion */
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { useTenant } from "hooks/settings";
import { Loaded, loadedEndpoint } from "models/loaded";
import {
  StrategyDashboardPriceData,
  useGetStrategyDashboardPricesQuery,
} from "src/store/api/generatedApi";
import {
  GroupedPriceSeries,
  PriceTimeSeries,
  PriceTimeSeriesKey,
} from "../types";

dayjs.extend(utc);

export const useStrategyDashboardPrices = (
  start?: string,
  end?: string
): Loaded<GroupedPriceSeries> => {
  const loadedRawData = loadedEndpoint(
    useGetStrategyDashboardPricesQuery({ tenantName: useTenant(), start, end })
  );
  if (loadedRawData.status === "success") {
    return {
      status: "success",
      data: buildGroupedPriceSeries(loadedRawData.data),
      fetching: loadedRawData.fetching,
    };
  }
  return loadedRawData;
};

const buildGroupedPriceSeries = (
  data: StrategyDashboardPriceData
): GroupedPriceSeries => {
  const stringKeyKeyMap: Record<string, PriceTimeSeriesKey> = {};
  const stringKeyValuesMap: Record<string, PriceTimeSeries> = {};

  for (const item of data.series) {
    const key: PriceTimeSeriesKey = {
      priceSource: item.price_source,
      materialName: item.material_name,
    };
    const stringKey = JSON.stringify(key);
    stringKeyKeyMap[stringKey] = key;

    const value = stringKeyValuesMap[stringKey] ?? {
      validFrom: [],
      specificPrice: [],
    };
    value.validFrom.push(dayjs.utc(item.price_valid_from));
    value.specificPrice.push(item.specific_price);
    stringKeyValuesMap[stringKey] = value;
  }

  const values: [PriceTimeSeriesKey, PriceTimeSeries][] = Object.entries(
    stringKeyKeyMap
  ).map(([stringKey, key]) => [key, stringKeyValuesMap[stringKey]!]);

  return {
    items: values,
    availableMaterialNames: data.materials,
    availablePriceSources: data.price_sources,
  };
};
